export default __webpack_public_path__ + "static/media/article6.98f600a4.png";